import { render, staticRenderFns } from "./ProductsBundlePreview.vue?vue&type=template&id=6d108986&"
import script from "./ProductsBundlePreview.vue?vue&type=script&lang=js&"
export * from "./ProductsBundlePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports